import { EXPORT_STATUSES } from "../../screens/exports/constants";
import template from "./index.html";
import "./index.less";

function controller(appState, $logger) {
	const ctrl = this;

	ctrl.$onChanges = onChanges;

	ctrl.$onInit = () => {
		ctrl.form = appState.forms.selected;
		ctrl.canAmend = appState.permissions.Reporting.Actions.CanAmend;
		ctrl.status = getStatus();
	};

	function onChanges() {
		ctrl.status = getStatus();
	}

	function getStatus() {
		const externalStatus = loadExternalStatus();
		if(externalStatus !== undefined) {
			return externalStatus;
		}

		const exportLog = ctrl.exportLog;

		if(!exportLog.Errored && !exportLog.Pending && !exportLog.Committed && !exportLog.Suppressed) {
			return {
				text: "Pending",
				style: "warning",
				icon: undefined
			};
		}
		if(exportLog.Errored !== undefined && exportLog.Errored > 0) {
			return {
				text: "Errored",
				style: "danger",
				icon: "zmdi-alert-octagon"
			};
		}
		if(exportLog.Pending !== undefined && exportLog.Pending > 0) {
			return {
				text: "Pending",
				style: "warning",
				icon: undefined
			};
		}
		if((exportLog?.Committed ?? 0) + (exportLog?.Suppressed ?? 0) > 0) {
			return {
				text: "Completed",
				style: "success",
				icon: "zmdi-check"
			};
		}
		return {
			text: "Unknown",
			style: "info",
			icon: "zmdi-delete"
		};
	}

	function loadExternalStatus() {
		if(ctrl.externalStatus === undefined) {
			return undefined;
		}

		switch(ctrl.externalStatus) {
			case EXPORT_STATUSES.pending:
				return {
					text: "Pending",
					style: "warning",
					icon: undefined
				};
			
			case EXPORT_STATUSES.suppressed:
				return {
					text: "Suppressed",
					style: "info",
					icon: "zmdi-delete"
				};
				
			case EXPORT_STATUSES.errored:
				return {
					text: "Errored",
					style: "danger",
					icon: "zmdi-alert-octagon"
				};
					
			case EXPORT_STATUSES.committed:
				return {
					text: "Completed",
					style: "success",
					icon: "zmdi-check"
				};
						
			default: 
				return {
					text: "Unknown",
					style: "info",
					icon: "zmdi-delete"
				};
		}
	}
}

export default angular
	.module("vesl.components.export-status", [])
	.component("exportStatus", {
		template,
		controller,
		bindings: {
			exportLog: "<",
			externalStatus: "<"
		}
	}).name;
